import { render, staticRenderFns } from "./wizard.component.vue?vue&type=template&id=7ccef18e&scoped=true&"
import script from "./wizard.component.vue?vue&type=script&lang=ts&"
export * from "./wizard.component.vue?vue&type=script&lang=ts&"
import style0 from "./wizard.component.vue?vue&type=style&index=0&id=7ccef18e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccef18e",
  null
  
)

export default component.exports